import React from 'react';

export const TermsIcon = () => (
  <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0V20H15.6177V0H0ZM14.4453 18.8276H1.17245V1.17245H14.4452L14.4453 18.8276Z" fill="currentColor"/>
    <path d="M12.8466 2.34473H2.77106V5.86207H12.8466V2.34473H12.8466ZM11.6742 4.68962H3.9435V3.51717H11.6742V4.68962H11.6742Z" fill="currentColor"/>
    <path d="M2.77106 11.793H3.9435V12.9654H2.77106V11.793Z" fill="currentColor"/>
    <path d="M2.77106 14.1377H3.9435V15.3101H2.77106V14.1377Z" fill="currentColor"/>
    <path d="M2.77106 16.4824H3.9435V17.6549H2.77106V16.4824Z" fill="currentColor"/>
    <path d="M5.11597 11.793H12.8467V12.9654H5.11597V11.793Z" fill="currentColor"/>
    <path d="M2.77106 9.44775H3.9435V10.6202H2.77106V9.44775Z" fill="currentColor"/>
    <path d="M5.11597 9.44775H12.8467V10.6202H5.11597V9.44775Z" fill="currentColor"/>
    <path d="M2.77106 7.10303H3.9435V8.27547H2.77106V7.10303Z" fill="currentColor"/>
    <path d="M5.11597 7.10303H12.8467V8.27547H5.11597V7.10303Z" fill="currentColor"/>
    <path d="M5.11597 14.1377H12.8467V15.3101H5.11597V14.1377Z" fill="currentColor"/>
    <path d="M5.11597 16.4824H12.8467V17.6549H5.11597V16.4824Z" fill="currentColor"/>
  </svg>
);
